import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Topbar from "./Components/Topbar";

const { Content } = Layout;

const WorkerLayout = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Topbar />
      <Layout>
        <Content
          style={{
            background: "#fff",
            minHeight: "calc(100vh - 64px)",
            padding: "24px 32px",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default WorkerLayout;
